import { render, staticRenderFns } from "./manage-topic.vue?vue&type=template&id=317dd5ce&scoped=true"
import script from "./manage-topic.vue?vue&type=script&lang=js"
export * from "./manage-topic.vue?vue&type=script&lang=js"
import style0 from "./manage-topic.vue?vue&type=style&index=0&id=317dd5ce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317dd5ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('317dd5ce')) {
      api.createRecord('317dd5ce', component.options)
    } else {
      api.reload('317dd5ce', component.options)
    }
    module.hot.accept("./manage-topic.vue?vue&type=template&id=317dd5ce&scoped=true", function () {
      api.rerender('317dd5ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/planning/activity-detail/manage-topic.vue"
export default component.exports